// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import clsx from 'clsx';
import styles from '../../../../select/parts/styles.css.js';
export default function OptionGroup({ children, virtual, ariaLabelledby, ariaDisabled }) {
    return (React.createElement("div", { role: "group", className: clsx(styles['option-group'], virtual && styles.virtual), "aria-labelledby": ariaLabelledby, "aria-disabled": ariaDisabled }, children));
}
//# sourceMappingURL=option-group.js.map